import { Image } from "antd";
const defaultRender = (value) => (value  ? value : '--');
const columns = [
  {
    title: "Image",
    dataIndex: "url",
    key: "url",
    reder: defaultRender,    
    width: 100
  },
  {
    title: "Width",
    dataIndex: "width",
    width: 100
  },
  {
    title: "Height",
    dataIndex: "height",
    width: 100
  },
 
  {
    title: "Created Date",
    dataIndex: "createdDate",
    sorter: (a, b) => ((new Date(a.createdDate)) - (new Date(b.createdDate))),
    width: 100
  },
 
  {
    title: "Copy Iframe",
    dataIndex: "actions",
    width: 100
  },
];

export default columns;
